import { useQuery } from "@tanstack/react-query";
import { getAllSchools } from "../../api/apiSchools";
import i18next from "i18next";

export function useGetSchools(page = 1, perPage = 15, filters = {}) {
    const { isLoading, data, error } = useQuery({
        queryKey: ["schools", page, perPage, filters, i18next.language],
        queryFn: () => getAllSchools(page, perPage, filters),
        retry: false,
    });

    const schools = data?.data?.items || [];
    const meta = data?.data?.meta || { current_page: 1, per_page: perPage, total: 0 };

    return { isLoading, error, schools, meta };
}
